import PropTypes from 'prop-types';
import React from 'react';
import { matchPath } from 'react-router';
import NavItem from 'src/layouts/DashboardLayout/NavBar/NavItem';
import NavItemsParent from 'src/layouts/DashboardLayout/NavBar/NavItemsParent';
import helpers from 'src/helpers';

function NavItemsChild({
  pathname,
  isPageBlocked,
  doesUserHaveSubscription,
  item,
  depth,
  userRolePermissions,
}) {
  const {
    icon,
    info,
    title,
    click,
    items,
    href,
    isShownWhenOtherHidden,
    permissions,
    requiredPermissions,
    additionalOptions,
  } = item;
  const open = matchPath(pathname, {
    path: href,
    exact: false
  });

  if (permissions && !helpers.permissions.doesUserHaveOneOfPermissions(permissions, userRolePermissions)) {
    return null;
  }

  // CON-1487 Phase G — AND semantics for admin-sidebar items.
  // `requiredPermissions` (all-must-hold) coexists with `permissions`
  // (any-may-hold); both must pass if both are present.
  if (Array.isArray(requiredPermissions) && requiredPermissions.length) {
    const hasAll = requiredPermissions.every((p) => (
      helpers.permissions.doesUserHavePermission(p, userRolePermissions)
    ));
    if (!hasAll) return null;
  }

  return (
    <NavItem
      key={`${title}${depth}`}
      depth={depth}
      icon={icon}
      info={info}
      title={title}
      click={click}
      isPageBlocked={isPageBlocked}
      doesUserHaveSubscription={doesUserHaveSubscription}
      isShownWhenOtherHidden={isShownWhenOtherHidden}
      additionalOptions={additionalOptions}
      {...items ? { open } : { href }}
    >
      {items && (
        <NavItemsParent
          depth={depth + 1}
          pathname={pathname}
          items={items}
          isPageBlocked={isPageBlocked}
          doesUserHaveSubscription={doesUserHaveSubscription}
        />
      )}
    </NavItem>
  );
}

NavItemsChild.propTypes = {
  item: PropTypes.object.isRequired,
  isPageBlocked: PropTypes.bool.isRequired,
  doesUserHaveSubscription: PropTypes.bool.isRequired,
  pathname: PropTypes.string,
  depth: PropTypes.number,
  userRolePermissions: PropTypes.array,
};

NavItemsChild.defaultProps = {
  depth: 0,
  pathname: '',
  userRolePermissions: [],
};

export default NavItemsChild;
